import React from "react";
import { useParams } from "react-router-dom";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

const CONTENT = {
  terms: {
    title: "Terms of Service",
    body: `These terms govern your use of ExactReach. Placeholder content — final legal text requires review by counsel before launch.

1. Acceptance of terms
2. Use of the platform
3. Order process and payment
4. Data licensing and permitted use
5. Cancellations and replacements
6. Warranties and disclaimers
7. Liability limitations
8. Governing law`,
  },
  privacy: {
    title: "Privacy Policy",
    body: `We collect and process personal data to deliver our services. Placeholder content — subject to legal review.

1. Information we collect
2. How we use information
3. Legal basis for processing
4. Data retention
5. Your rights
6. International transfers
7. Contact and complaints`,
  },
  data: {
    title: "Data Processing and Usage Policy",
    body: `Placeholder content covering:

1. Categories of data we license and deliver
2. Permitted use of delivered data
3. Prohibited uses
4. Compliance with applicable data-protection law
5. Suppression lists and opt-outs
6. Data source disclosure at aggregate level

Subject to legal review before launch.`,
  },
  refund: {
    title: "Refund and Replacement Policy",
    body: `Within 30 days of delivery (configurable) you may submit a replacement request with affected records and a reason. Replacements are considered case-by-case.

Placeholder content — final policy subject to legal review.`,
  },
  aup: {
    title: "Acceptable Use Policy",
    body: `You agree not to:
- Use delivered data for consumer marketing outside a lawful business context
- Resell or transfer data without written authorisation
- Reverse-engineer or scrape the platform
- Bypass usage limits

Placeholder — subject to legal review.`,
  },
  cookies: {
    title: "Cookie Policy",
    body: `We use strictly necessary cookies to maintain your session and analytics cookies (with consent) to understand product usage.

Placeholder content — subject to legal review.`,
  },
};

export default function Legal() {
  const { slug } = useParams();
  const doc = CONTENT[slug] || CONTENT.terms;
  return (
    <div className="App min-h-screen">
      <Navbar />
      <section className="section">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-3">Legal</div>
          <h1 className="font-heading font-black tracking-tighter text-4xl md:text-5xl mb-4">{doc.title}</h1>
          <p className="text-xs text-amber-800 bg-amber-50 border border-amber-200 px-3 py-2 mb-8 font-mono">
            PLACEHOLDER — This content requires legal review before launch.
          </p>
          <pre className="whitespace-pre-wrap text-sm text-muted-foreground leading-relaxed font-body">{doc.body}</pre>
        </div>
      </section>
      <Footer />
    </div>
  );
}
